import cx from 'classnames'
import styles from './Day.module.scss'
import { getCalendarDayClasses, getUniqueArtists, getMarkedEventTimes } from '../../../../utils'
import { DATE_FORMAT } from '~constants'
import { DayEvent } from '../DayEvent/DayEvent'
import type { ArtistProps, CalendarDayEventProps } from '../../../../types'
import type { FormattedEvent } from '../../../../types/Event'
import { NO_SHOW_TODAY } from 'constants/calendar'

type DayProps = {
  dayInfo: CalendarDayEventProps
  artists: ArtistProps[]
  isTablet: boolean
  isDesktop: boolean
  isLastWeekOfMonth: boolean
  handleDateSelection: (events: FormattedEvent[], artist: ArtistProps) => void
}

export const Day = ({ dayInfo, artists, isTablet, isDesktop, isLastWeekOfMonth, handleDateSelection }: DayProps) => {
  const day = dayInfo.date
  const dayKey = isDesktop ? day.format(DATE_FORMAT.DATE_TIME) : day.format(DATE_FORMAT.SHORT_DATE_FORMAT)

  const cellClasses = getCalendarDayClasses(dayInfo)
    .split(' ')
    .map(cls => styles[cls])

  const uniqueArtists = getUniqueArtists(dayInfo)

  const shouldShowNoEvents =
    !dayInfo.isPastDate &&
    dayInfo.events.length === 0 &&
    (isTablet || !dayInfo.isFromBeforeCurrentMonth || isLastWeekOfMonth)

  return (
    <div key={dayKey} className={cx(cellClasses)}>
      {isTablet && (
        <div className={styles['calendar__day-header']}>
          <div className={styles['grid-day']}>{day.format(DATE_FORMAT.SHORT_DAY)}</div>
          <div className={styles['grid-date']}>{day.format(DATE_FORMAT.SHORT_DATE)}</div>
        </div>
      )}

      {isDesktop && !dayInfo.isFromBeforeCurrentMonth && (
        <div className={styles['calendar__day-header']}>{day.date()}</div>
      )}

      <div className={styles['calendar__day-wrapper']}>
        {uniqueArtists.map((event, idx) => {
          const artist = artists.find(a => a.artistId === event.artistId) as ArtistProps
          if (dayInfo.isPastDate) return null

          return (
            <DayEvent
              key={artist.artistId || idx}
              artist={artist}
              event={dayInfo.events}
              eventsTime={getMarkedEventTimes(dayInfo.events, artist.artistId)}
              handleDateSelection={handleDateSelection}
            />
          )
        })}

        {shouldShowNoEvents && (
          <div className={styles['calendar__no-events']}>
            <span>{NO_SHOW_TODAY}</span>
          </div>
        )}
      </div>
    </div>
  )
}
export default Day
